import unitSqareBiliniearInterpolationFn from './unitSqareBiliniearInterpolationFn.js';

// returns a function that interpolates between four three-component colors
// x,y inputs of that function are on the unit square
// you can kind of think about them as "percent left" and "percent up" "between these four colors"
/*

x0y1-----x1y1
 |         |
 |         c
 |         |
x0y0-----x1y0

c = fourColorMixFn(x0y0, x0y1, x1y0, x1y1)( 1, 0.5 )
*/
export default function fourColorMixFn( x0y0, x0y1, x1y0, x1y1 ) {

	const x_ = unitSqareBiliniearInterpolationFn(
		x0y0[0],
		x0y1[0],
		x1y0[0],
		x1y1[0]
	);
	const y_ = unitSqareBiliniearInterpolationFn(
		x0y0[1],
		x0y1[1],
		x1y0[1],
		x1y1[1]
	);
	const z_ = unitSqareBiliniearInterpolationFn(
		x0y0[2],
		x0y1[2],
		x1y0[2],
		x1y1[2]
	);
	
	return ( x, y ) => [ x_(x,y), y_(x,y), z_(x,y) ];

}
